import React, { Component } from 'react';
import Title from './Title.js';
import NavBar from './NavBar.js';


export default class MenuBar extends Component {
  render() {
    return (
      <div className='menu-bar'>
        <Title />
        <NavBar showWork={this.props.showWork} toggleWork={this.props.toggleWork} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MenuBar.js